import React from 'react';

import { appColors } from 'src/theme';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon, useSvgId } from './icon-utils';

// Darker than `warning.main` so a status line stays legible on white.
export const ATTENTION_AMBER = '#B7791F';

/** The badge on a CRM logo whose connection needs an admin; the counterpart of `CRMConnectedIcon`. */
export function CRMAttentionIcon({ className }: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="16"
      viewBoxDimensions="0 0 16 16"
      width="16"
    >
      <circle cx="8" cy="8" fill="white" r="8" />
      <circle cx="8" cy="8" fill={ATTENTION_AMBER} r="6.6667" />
      <path d="M7.3335 4.33203H8.66683V8.9987H7.3335V4.33203Z" fill="white" />
      <circle cx="8" cy="10.9987" fill="white" r="0.8333" />
    </SimpleIcon>
  );
}

export function CRMConnectedIcon({ className }: SimpleIconInterface) {
  const clipPathId = useSvgId('crm-connected-clip');

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height="16"
      viewBoxDimensions="0 0 16 16"
      width="16"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <circle cx="8" cy="8" fill="white" r="8" />
        <path
          d="M7.06683 11.0654L11.7668 6.36536L10.8335 5.43203L7.06683 9.1987L5.16683 7.2987L4.2335 8.23203L7.06683 11.0654ZM8.00016 14.6654C7.07794 14.6654 6.21127 14.4904 5.40016 14.1404C4.58905 13.7904 3.8835 13.3154 3.2835 12.7154C2.6835 12.1154 2.2085 11.4098 1.8585 10.5987C1.5085 9.78759 1.3335 8.92092 1.3335 7.9987C1.3335 7.07648 1.5085 6.20981 1.8585 5.3987C2.2085 4.58759 2.6835 3.88203 3.2835 3.28203C3.8835 2.68203 4.58905 2.20703 5.40016 1.85703C6.21127 1.50703 7.07794 1.33203 8.00016 1.33203C8.92238 1.33203 9.78905 1.50703 10.6002 1.85703C11.4113 2.20703 12.1168 2.68203 12.7168 3.28203C13.3168 3.88203 13.7918 4.58759 14.1418 5.3987C14.4918 6.20981 14.6668 7.07648 14.6668 7.9987C14.6668 8.92092 14.4918 9.78759 14.1418 10.5987C13.7918 11.4098 13.3168 12.1154 12.7168 12.7154C12.1168 13.3154 11.4113 13.7904 10.6002 14.1404C9.78905 14.4904 8.92238 14.6654 8.00016 14.6654Z"
          fill={appColors.connectedCheck}
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
